import http from '../../utils/httpClient';

const state = {
  facilityGroup: []
};

const mutations = {
  setFacilityGroup(state, data) {
    console.log('🐈');
    console.log(data);
    state.facilityGroup = data;
  }
};

const actions = {
  async fetchFacilityGroup(context) {
    return await http.get('facilitygroup').then(res => {
      context.commit('setFacilityGroup', res.data);
    });
  },
  async updateFacilityGroup(context, data) {
    return await http.put(`facilitygroup/${data.id}`, data);
  },
  async insertFacilityGroup(context, data) {
    return await http.post('facilitygroup', data);
  },
  async deleteFacilityGroup(context, data) {
    return await http.delete(`facilitygroup/${data.id}`);
  }
};

export default {
  state,
  mutations,
  actions
};
